(function() {
  const buttons = document.querySelectorAll('.button-single-bundle');
  function updateActiveState() {
    const url = window.location.href;
    let anyFilterActive = false;
    buttons.forEach(btn => {
      const btnUrl = btn.getAttribute('data-url');
      const filterParam = btnUrl.split('?')[1];
      if (filterParam) {
        if (url.includes(filterParam.split('&')[0])) {
          btn.classList.add('active');
          anyFilterActive = true;
        } else {
          btn.classList.remove('active');
        }
      }
    });
    buttons.forEach(btn => {
      const btnUrl = btn.getAttribute('data-url');
      const filterParam = btnUrl.split('?')[1];
      if (!filterParam) {
        if (anyFilterActive) {
          btn.classList.remove('active');
        } else {
          btn.classList.add('active');
        }
      }
    });
  }
  buttons.forEach(btn => {
    btn.addEventListener('click', function() {
      buttons.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
    });
  });
  updateActiveState();
  const shop = document.querySelector('shop-component');
  if (shop) {
    shop.addEventListener('filtersUpdated', function() {
      updateActiveState();
    });
  }
  window.addEventListener('popstate', updateActiveState);
})();

